import React from 'react';

import { MenuItemChildren } from './MenuItemChildren';

/**
 * This function gets provided data from createMenuItems(),
 * which will be displayed as a html list-item.
 * If these items have children, the MenuItemChildren-function gets called.
 *
 * @param {json} { menuData } navigation-items provided by createMenuItems()
 */
export function MenuItem({ menuData, activePath, widgets }) {
  let link = (
    <a href={menuData.target} title={menuData.title}>
      {menuData.title}
    </a>
  );
  let mobileLink;

  if (menuData.mobile_title) {
    link = (
      <a href={menuData.target} title={menuData.title} className="hidden-mobile">
        {menuData.title}
      </a>
    );
    mobileLink = (
      <a href={menuData.target} title={menuData.title} className="hidden-desktop">
        {menuData.mobile_title}
      </a>
    );
  }

  // add a class for list items on the active navigation path
  function addClassForActivePath() {
    const currentId = menuData.id,
          notTopLevel = activePath.length > 2;
    let returnedClass = '';

    if (notTopLevel && activePath.indexOf(currentId) > -1) {
      returnedClass = 'menu-item-active';
    }

    return returnedClass;
  }

  // there are only mobile links for the first layer
  // that means, the menu item children are the second layer
  // so we can wrap it to render a container around the mega navigation
  // we do not want that wrapper around a third or more layer
  if (mobileLink) {
    return (
      <li className={addClassForActivePath()}>
        {link}
        {mobileLink}
        <div className="second-layer-wrapper">
          <MenuItemChildren
            currentId={menuData.id}
            menuData={menuData.children}
            activePath={activePath}
            widgets={widgets}
          />
        </div>
      </li>
    );
  }

  return (
    <li className={addClassForActivePath()}>
      {link}
      <MenuItemChildren
        currentId={menuData.id}
        menuData={menuData.children}
        activePath={activePath}
        widgets={widgets}
      />
    </li>
  );
}

MenuItem.propTypes = {
  menuData: React.PropTypes.object,
  activePath: React.PropTypes.array,
  widgets: React.PropTypes.array
};



// WEBPACK FOOTER //
// ./components/MenuItem.js